<template>
  <div class="h5 pa2">
    <h1>Sobre</h1>
    <p>Descrever o projeto aqui</p>
  </div>
</template>

